module.exports = __webpack_public_path__ + "static/media/help-disk-news.f36e7475.svg";